import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchGesamtpreisInfo } from './gesamtpreisHinweisSaga';
import { watchRbdMaxReceived } from './rbdMaxReceivedSaga';
import { watchKDVMetadaten } from './kdvMetadatenSaga';
import { watchVereinbarungenUebernehmen } from './vereinbarungenUebernehmenSaga';
import { quoteDbSaga } from './quoteDbSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchRabattHinweis } from './treuebonusSaga';
import { watchInitialStoreManagementDataRequested } from './createInitialStoreManagementDataSaga';
import { logoutSaga } from './logoutSaga';
import { versicherungsnehmerSaga } from './versicherungsnehmerSaga';
import { watchKooperationenRequest } from './kooperationenSaga';
import { watchRabattServiceRequest } from './rabattServiceSaga';
import { watchKontaflex } from './kontaflexToolbarSaga';

export function* rootSaga() {
  yield all([
    watchGesamtpreisInfo(),
    watchRbdMaxReceived(),
    watchKDVMetadaten(),
    watchVereinbarungenUebernehmen(),
    quoteDbSaga(),
    watchStateSnapshot(),
    watchRabattHinweis(),
    watchInitialStoreManagementDataRequested(),
    logoutSaga(),
    versicherungsnehmerSaga(),
    watchKooperationenRequest(),
    watchRabattServiceRequest(),
    watchKontaflex(),
  ]);
}
